import ApliClient from '../factory/ww-api';

const updateCustomFields = async (
    publicKey,
    tenantId,
    host,
    clientId,
    userName,
    password,
    ownerId,
    brokerId,
    brokerName,
    blipToken
) => {
    const api = ApliClient;
    const config = {
        headers: {
            Authorization: publicKey
        }
    };
    const { data } = await api.post(
        'dynamics2/settings',
        {
            publicKey,
            tenantId,
            host,
            clientId,
            userName,
            password,
            ownerId,
            brokerId,
            brokerName,
            blipToken
        },
        config
    );
    return data;
};

export { updateCustomFields };
